export const connectorTypes = {
    U: 'Not Set',
    T2: 'Type 2',
    CCS: 'Type 2 - Combo CCS',
    C: 'CHAdeMO',
    T1: 'Type 1',
    T1CCS: 'Type 1 - Combo CCS',
    D: 'Domestic',
    G: 'GB/T'
}